module.exports = __webpack_public_path__ + "img/repeat.6ec5bad1.svg";